import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

// Takes the already-composed route text rather than journey objects -- persistFlightCartSelection
// (the one dispatch site) already builds the sibling selected_flight_itinerary committed-state
// entry for the same real-world action, and its own displayText is exactly this fact in prose.
// Re-deriving the route text a second time here would be the exact duplicated-enrichment-logic
// this codebase's own sendMessage/handleSubmit precedent avoids.
export function buildFlightCartSelectionChangedActivityEntry(
  displayText: string,
): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'flight_cart_selection_changed',
    label: 'Selected flight for cart',
    displayText: boundActivityDisplayText(displayText),
    sourcePath: 'trip_planner.cart.flight_selection',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
